import { render, staticRenderFns } from "./AppDownloadLinkPanel.vue?vue&type=template&id=39307181&scoped=true&"
import script from "./AppDownloadLinkPanel.vue?vue&type=script&lang=js&"
export * from "./AppDownloadLinkPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadLinkPanel.vue?vue&type=style&index=0&id=39307181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39307181",
  null
  
)

export default component.exports